import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationDeleteVariationRatingsArgs,
  BackendVariationRating,
} from 'src/types/backend';

import { VARIATION_RATING_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation DeleteVariationRatings($projectId: ID!, $generationTool: GenerationToolEnum!) {
    deleteVariationRatings(projectId: $projectId, generationTool: $generationTool) {
      ...VariationRating
    }
  }
  ${VARIATION_RATING_FRAGMENT}
`;

type Variables = BackendMutationDeleteVariationRatingsArgs;
type Result = BackendVariationRating[];

export const deleteVariationRatings = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
